import React, { useState } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AccountCircle from '@mui/icons-material/AccountCircle';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard'; // or any other icon

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#BE9F55',
});

const LogoTypography = styled(Typography)({
  flexGrow: 1,
  cursor: 'pointer',
  fontWeight: 'bold',
  color: '#ffffff',
  fontSize: '2rem',
  letterSpacing: '2px',
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  transition: 'color 0.3s ease',
  '&:hover': {
    color: 'grey',
  },
});

const TopBar = ({ username, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogoClick = () => {
    navigate('/landing');
  };

  const handleLogoutClick = () => {
    onLogout();
    navigate('/login');
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleDashboardClick = () => {
    navigate('/landing'); // or '/dashboard' depending on your setup
  };

  return (
    <StyledAppBar position="fixed">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: { xs: 1, sm: 2, md: 3 } }}>
        <LogoTypography
          variant="h5"
          component="div"
          onClick={handleLogoClick}
          sx={{
            fontSize: { xs: '1.2rem', sm: '2rem' },
            flexGrow: 1,
          }}
        >
     {/* Elite Travel Experts / Travel Organisers */}
     Managed Agents
        </LogoTypography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {location.pathname === '/layout' && (
          <Button
          variant="contained"
          onClick={handleDashboardClick}
          startIcon={<SpaceDashboardIcon />}
          sx={{
            color: 'white',
            backgroundColor: '#5e5b5b',
            mr: 2,
            fontSize: { xs: '0.7rem', sm: '0.9rem' },
            px: { xs: 1, sm: 2 },
            minWidth: 'auto',
            '&:hover': {
              backgroundColor: '#4b4a4a',
              color: 'black',
            },
          }}
        >
            Dashboard
          </Button>
        )}
</Box>
        <Box display="flex" alignItems="center">
          <Typography className='user-body' component="div" sx={{ color: '#ffffff', marginRight: '10px', display: { xs: 'none', sm: 'block' }} }>
            Welcome, {username}
          </Typography>
          <IconButton
            size="large"
            edge="end"
    
            aria-label="account"
            onClick={handleMenuClick}
            sx={{ color: 'white' }}
          >
            <AccountCircle sx={{
      fontSize: { xs: 30, sm: 32, md: 32 }, // Responsive icon size
    }}/>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

export default TopBar;
